export class SessionConstants {
    public static readonly classSearch = 'class-search';
    public static readonly classCurriculumSearch = 'class_curriculum_search';
    public static readonly contentFolderSearch = 'contentFolderSearch';
    public static readonly assignSearch = 'assign-search';
    public static readonly assessSearch = 'assess-search';
    public static readonly studentWorkSearch = 'studentWork-search';
    public static readonly curriculumStudentWorkSearch = 'curriculum_studentWork_search';
    public static readonly directcontentSearch = 'content-search';
    public static readonly non_directcontentSearch = 'non_content-search';

    // Student Side Search Session Key Name

    public static readonly studentHomeSearch = 'student_home-search';
    public static readonly studentClassSearch = 'student_class-search';
    public static readonly studentAssignmentSearch = 'student_assignment-search';
    public static readonly studentAssessmentSearch = 'student_assessment-search';
    public static readonly studentResourceSearch = 'student_resource-search';
}
